import { PATH_DASHBOARD } from '@/routes/paths';
import { Link } from '@mui/material';
import { Link as LinkRouter } from 'react-router-dom';

type Props = {
    id?: string;
  value: string;
};
export const LinkLabel = ({ value, id }: Props) => (
  <LinkRouter style={{ textDecoration: 'none' }} to={PATH_DASHBOARD.reservations.view(id ?? value)}>
    <Link>{value} </Link>
  </LinkRouter>
);
